import { useState } from "react";
import { useSelector ,useDispatch} from "react-redux";
import axios from "axios";
import {toast} from 'react-toastify'
import { getProductDetails } from '../../redux/actions';
import Cookies from 'js-cookie'
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";

const ClaimListing = ({verifytoggle,productId,socket}) => {

    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;
  const [color, setColor] = useState("#ffffff");
    const [letter1, setLetter1] = useState("");
    const [letter2, setLetter2] = useState("");
    const [letter3, setLetter3] = useState("");
    const [letter4, setLetter4] = useState("");
    const [letter5, setLetter5] = useState("");
    const [letter6, setLetter6] = useState("");
    const [loading, setLoading] = useState(false);
const [disable, setdisable] = useState(false)
  const dispatch=useDispatch()
    const user = useSelector((state) => state.userDetails.user);
    const products = useSelector((state) => state.productDetails.details);
const Submit=async()=>{

    setdisable(true);
    setLoading(true);
    if(letter1.length!=0 && letter2.length!=0 && letter3.length!=0 && letter4.length!=0 && letter5.length!=0 && letter6.length!=0 )
    {
        const code=letter1+letter2+letter3+letter4+letter5+letter6;
        const response = await axios.request({
            data: { id: products._id,code:code,user_name:user.firstname,user_id:user._id },
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Cookies.get('token')
            },
            url: `${process.env.REACT_APP_SERVER_URL}/v1/dashboard-products/claimed-product`
        })

        // alert(JSON.stringify(response))
        if (response.data.success) {
            verifytoggle()
            socket.emit("new_notification", 
            { 
            name: user.firstname, 
            email:user.email,
            message: `has claimed your ${products.title} listing`
        }
            );

            const url = process.env.REACT_APP_SERVER_URL;
            const endpoint = `${url}/v1/notifications/add-notifications`
            const data={ name:user.firstname, email:user.email, message:`has claimed your ${products.title} listing` }
            await axios({ data, headers: {'Content-Type': 'application/json','Authorization': Cookies.get('token')}, method: 'post',  timeout: 1000 * 60 * 10, url: endpoint, });
            dispatch(getProductDetails(productId));
            toast.success(response.data.message)
        }
        else{

            toast.error(response.data.message)
        }

    }
    else
    {
        toast.error("Code not correct!")
    }
    setdisable(false);
    setLoading(false);

}



     


    return (<>
    
    {/* <div id="claim-listing" className="modal fades" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"> */}
  
            <div className="modal-dialog modal-width" role="document">
                 <div className="modal-content ">
                    <div className="modal-body p-5">
                        <h4 className="text-center  modal-heading">Enter invitation code to claim your page</h4>  
                        <div className="code-box my-5 d-flex justify-content-center">
                            <span><input type="text" placeholder="-" name="l1" value={letter1}       onChange={(e)=>{let value=e.target.value; if(/^[a-zA-Z]*$/.test(value)){value=value.toUpperCase();} if (letter1.length<1){setLetter1(value);const nextfield = document.querySelector(`input[name=l2]`); if (nextfield !== null) { nextfield.focus();}}}} /></span>
                            <span><input type="text" placeholder="-" name="l2" value={letter2}  onKeyDown={(e)=>{          const backfield = document.querySelector(`input[name=l1]`);   if (e.keyCode === 8) {setLetter1('');backfield.focus() } }} onChange={(e)=>{let value=e.target.value; if(/^[a-zA-Z]*$/.test(value)){value=value.toUpperCase();} if (letter2.length<1){setLetter2(value);const nextfield = document.querySelector(`input[name=l3]`); if (nextfield !== null) { nextfield.focus();}}}} /></span>
                            <span><input type="text" placeholder="-" name="l3" value={letter3}  onKeyDown={(e)=>{          const backfield = document.querySelector(`input[name=l2]`);   if (e.keyCode === 8) {setLetter2('');backfield.focus() } }} onChange={(e)=>{let value=e.target.value; if(/^[a-zA-Z]*$/.test(value)){value=value.toUpperCase();} if (letter3.length<1){setLetter3(value);const nextfield = document.querySelector(`input[name=l4]`); if (nextfield !== null) { nextfield.focus();}}}} /></span>
                            <span><input type="text" placeholder="-" name="l4" value={letter4}  onKeyDown={(e)=>{          const backfield = document.querySelector(`input[name=l3]`);   if (e.keyCode === 8) {setLetter3('');backfield.focus() } }} onChange={(e)=>{let value=e.target.value; if(/^[a-zA-Z]*$/.test(value)){value=value.toUpperCase();} if (letter4.length<1){setLetter4(value);const nextfield = document.querySelector(`input[name=l5]`); if (nextfield !== null) { nextfield.focus();}}}} /></span>
                            <span><input type="text" placeholder="-" name="l5" value={letter5}  onKeyDown={(e)=>{          const backfield = document.querySelector(`input[name=l4]`);   if (e.keyCode === 8) {setLetter4('');backfield.focus() } }} onChange={(e)=>{let value=e.target.value; if(/^[a-zA-Z]*$/.test(value)){value=value.toUpperCase();} if (letter5.length<1){setLetter5(value);const nextfield = document.querySelector(`input[name=l6]`); if (nextfield !== null) { nextfield.focus();}}}} /></span>
                            <span><input type="text" placeholder="-" name="l6" value={letter6}  onKeyDown={(e)=>{          const backfield = document.querySelector(`input[name=l5]`);   if (e.keyCode === 8) {setLetter5('');setLetter6('');backfield.focus() } }} onChange={(e)=>{let value=e.target.value; if(/^[a-zA-Z]*$/.test(value)){value=value.toUpperCase();} if (letter6.length<1){setLetter6(value);}}}  /></span>
                        </div>


                       


                        <div className="d-flex justify-content-center ">
                            <button type="button" onClick={Submit} disabled={disable} className="sub-button px-5">
                                
                            {loading && <SyncLoader color={color} loading={loading} css={override} size={11} />}
                      {!loading && <span> Verify </span>}
                                
                               </button>
                        </div>
                    </div>
                </div>
            </div>
 
        {/* </div> */}
        </>
    );
}

export default ClaimListing;